import { render, staticRenderFns } from "./device-model-add.vue?vue&type=template&id=6b8cd5a2&"
import script from "./device-model-add.vue?vue&type=script&lang=js&"
export * from "./device-model-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b8cd5a2')) {
      api.createRecord('6b8cd5a2', component.options)
    } else {
      api.reload('6b8cd5a2', component.options)
    }
    module.hot.accept("./device-model-add.vue?vue&type=template&id=6b8cd5a2&", function () {
      api.rerender('6b8cd5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/device-model/device-model-add.vue"
export default component.exports